module.exports = __webpack_public_path__ + "static/media/PaymentFail.c8a2b21a.png";